// The one focus indicator (design spec §6.10): an opaque 2 px outline in --ring, offset 2 px,
// or inset for rows, tabs and tree items that sit edge to edge. Never reduced opacity
// (contrast.test.ts); outline, not box-shadow, so it survives forced-colours mode.
export const FOCUS_RING =
  "outline-none focus-visible:outline-2 focus-visible:outline-solid focus-visible:outline-offset-2 focus-visible:outline-ring";

export const FOCUS_RING_INSET =
  "outline-none focus-visible:outline-2 focus-visible:outline-solid focus-visible:-outline-offset-2 focus-visible:outline-ring";

/** Text fields: the border turns --ring and a 2 px ring sits on it (design spec §6.8). */
export const FIELD_FOCUS =
  "outline-none focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring";
